import ProductDescription from './ProductDescription'

const BSCornmealProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '017BS',
  IsBroadband: true,
  Size: '',
  FDACert: false,
  Organic: false,
}

export default BSCornmealProduct
